<template>
    <section id="prop-notificartions" class="prop-notifications">
        <div class="notifications">
            <div v-if="loading" class="loader"/>
            <div class="massage urge" v-if="urgeGrowl > 0 && !loading">
                <svg>
                    <use xlink:href="#icon-trend" />
                </svg>
                <p v-if="urgeGrowl < 30">
                  <b>Only {{ urgeGrowl }}% of properties in this location remain for these dates.</b> Book today.
                </p>
                <p v-else>
                    <b>Prices can change hourly.</b><br>Book today to avoid
                    disappointment.
                </p>
            </div>
            <div
                class="massage stay-length"
                v-if="
                    propertyAvailable && nights < minimumStayLength && !loading
                "
            >
                <p>
                    You can <b>stay up to 7 nights</b> from this arrival date at
                    no extra cost.
                </p>
            </div>
            <div class="massage" v-if="wsGrowl && !loading">
                <svg class="witness">
                    <use xlink:href="#icon-witness" />
                </svg>
                <p v-if="wsGrowl === 1">
                    <b>{{ wsGrowl }} person </b>is currently viewing this
                    property.
                </p>
                <p v-else>
                    <b>{{ wsGrowl }} people </b>are currently viewing this property.
                </p>
            </div>
        </div>
    </section>
</template>

<script>
export default {
    data: function () {
        return {};
    },
    props: {
        loading: Boolean,
        price: Object,
        wsGrowl: Number,
        urgeGrowl: Number,
        minimumStayLength: Number,
        propertyAvailable: Boolean,
        nights: String,
    },
};
</script>

<style scoped lang="scss">
@import 'app/assets/stylesheets/_vars.scss';

.prop-notifications {
    margin: 1.25rem;
    padding-bottom: 1.25rem;
    border-bottom: 1px solid #d9d9d9;
}

.massage {
    display: flex;
    padding: 0.625rem 1.25rem;
    margin-top: 0.75rem;
    flex-direction: row;
    align-items: center;
    background: #fff8dc;
    border: 1px solid #ffde5a;
    border-radius: .25rem;

    &:first-child {
        margin-top: 0;
    }

    p {
        font-size: 0.75rem;
        @media #{$desktop} {
            font-size: 1rem;
        }
    }

    svg {
        min-width: 2rem;
        max-width: 2rem;
        height: 2rem;
        margin-right: 1.25rem;
    }

    p {
        color: #d22f30;
        font-size: 0.875rem;
        line-height: 1rem;
    }
}

.loader {
  appearance: none;
  margin-right: .625rem;
  margin-bottom: .625rem;
  min-height: 2rem;
  min-width: 11.25rem;
  width: 100%;
  height: auto;
  overflow: hidden;
  color: transparent !important;
  border: none !important;
  fill: transparent;
  text-shadow: none;
  box-sizing: border-box;
  box-shadow: none;
  will-change: background;
  background-color: #ccc;
  background-image: linear-gradient(90deg, #ddd 0, #e8e8e8 2.5rem, #ddd 5rem);
  background-size: 18.75rem;
  border-radius: 0.125rem;
  animation: shine-lines 1.6s infinite linear;
}

@keyframes shine-lines {
  0% {
    background-position: -6.25rem;
  }
  40%, 100% {
    background-position: 8.75rem;
  }
}
</style>
